<template>
<section id="curadoria">
	<Notification corner="bottom-right" :closed="true" />
	<container pathName="create">
		<div class="buttonAdd" v-if="this.$auth.user().perfil === 1" @click="formataStatesCuradoria(true)">ADICIONAR</div>

		<load-content v-if="loadContent && curadorias.length === 0" />

		<div class="relatorio" v-if="curadorias.length > 0">
			<a @click="exportTree(true)" href="javascript:void(0)">Exportar eixos</a>
		</div>

		<div v-else-if="inicial" class="objectNotFound">
				Nenhuma curadoria cadastrada :)
		</div>

		<div class="table-wrapper">
			<SubCuradorias v-for="(curadoria, index) in curadorias" :key="index" :permiteManipulacao="$auth.user().perfil === 1" :nodes="curadoria.subCuradorias" :label="curadoria.nome" :id="curadoria.id"
			:depth="0" :codigo="curadoria.codigo" :nomeUsuario="curadoria.nomeUsuario" :objetosTotal="curadoria.objetosTotal" :selectCuradoriaHandler="selectCuradoriaHandler" :isFirst="!index"></SubCuradorias>
		</div>
	</container>

	<div class="modal-blackscreen" v-if="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
		<div class="modal">
			<div class="modalLoading" v-if="modalLoading">
				<load-content />
			</div>

			<div class="adicionar">
				<i class="fas fa-plus"></i>
				<p>{{editarCuradoria ? 'Atualizar curadoria': 'Adicionar uma nova curadoria' }} </p>
			</div>

			<div class="input-container">
				<label for="nome_curadoria_input">Digite o nome da curadoria: </label>
				<input id="nome_curadoria_input" type="text" v-on:keyup.enter="() => salvarCuradoria()" placeholder="ex.: Tecnologia da Informação" v-model="curadoria.nome" />
			</div>

			<div class="two-columns" v-show="mostrarTiposQuestoes">
				<div class="input-container" v-if="!curadoria.curadoriaId">
					<label for="codigo_curadoria_input">Digite o código da curadoria: </label>
					<input id="codigo_curadoria_input" type="text" @keyup="curadoria.codigo = curadoria.codigo.toUpperCase()" v-on:keyup.enter="() => salvarCuradoria()" maxlength="2" placeholder="ex.: TC" :disabled="curadoria.id" v-model="curadoria.codigo" />
				</div>

				<div class="input-container" v-for="tipo in tiposQuestao" :key="tipo.id">
					<label>
						<span class="input-tipo-container">{{ tipo.descricao }}</span>
						Defina o número de questões:
					</label>
					<numberBox :pValue="tiposQuestaoAssociadas[tipo.id]" v-model="tiposQuestaoAssociadas[tipo.id]" :default="numeroDefaultAssociacao" />
				</div>
			</div>

			<div class="botoes">
				<button-action type="button" :onClick="closeModal" class="xs default" style="margin-right: 10px;">Cancelar</button-action>
				<button-action type="button" :onClick="() => salvarCuradoria()" class="xs blue">{{ editarCuradoria  ? 'ATUALIZAR' : 'ADICIONAR'}}</button-action>
			</div>
		</div>
	</div>

	<!-- Modal para confirmação de exclusão de área de conhecimento -->
	<Modal v-if="isModalDeleteVisible" @close="() => this.isModalDeleteVisible = !this.isModalDeleteVisible">
		<template v-slot:body>
			<p class="texto">Deseja remover a Curadoria <i>{{ removeItem[1] }}</i>?</p>
		</template>

		<template v-slot:footer>
			<button-action type="button" :onClick="() => deleteCuradoria()" class="xs danger">Confirmar</button-action>
			<button-action type="button" :onClick="closeModalDelete" class="xs default">Cancelar</button-action>
		</template>
	</Modal>
	<!-- Final exclusão de área de conhecimento  -->
</section>
</template>

<script>
import { curadoria } from '@/services/curadoria'
import { questoes } from '@/services/questoes'
import container from '@/components/shared/Container'
import SubCuradorias from '@/components/shared/SubCuradorias'
import LoadContent from '@/components/shared/LoadContent'
import EventBus from '@/components/event-bus'
import ButtonAction from '@/components/shared/ButtonAction'
import Modal from '@/components/shared/Modal'
import NumberBox from '@/components/shared/NumberBox'

export default {
	name: 'CuradoriaList',
	components: { container, LoadContent, SubCuradorias, ButtonAction, Modal, NumberBox },
	data () {
		return {
			curadorias: [],
			tiposQuestao: [],
			isModalVisible: false,
			isModalDeleteVisible: false,
			removeItem: [],
			loadContent: true,
			modalLoading: false,
			totalItens: 0,
			currentPage: 1,
			isFlashMessageVisible: false,
			curadoria: {
				curadoriaId: null,
				nome: '',
				flagAtivo: true /* ,
				codigo: '' */
			},
			numeroDefaultAssociacao: 10,
			tiposQuestaoAssociadas: {
				// ID: 'VALOR'
			},
			editarCuradoria: false,
			inicial: false,
			mostrarTiposQuestoes: false
		}
	},
	async created () {
		let getCuradorias = null

		getCuradorias = curadoria.find()

		await Promise.all([questoes.findTipos(), getCuradorias]).then(data => {
			this.tiposQuestao = data[0].data
			this.curadorias = data[1].data

			// Gera o array de associação com os valores zerados
			let i = 0
			for (i of this.tiposQuestao) {
				this.tiposQuestaoAssociadas[i.id] = this.numeroDefaultAssociacao
			}
		})

		this.loadContent = false
		this.inicial = true
		EventBus.$on('salvar-curadoria', (payLoad) => {
			this.formataStatesCuradoria()
			this.curadoria.curadoriaId = payLoad.id
		})
		EventBus.$on('editar-curadoria-subCuradoria', async (payLoad) => {
			this.editarCuradoria = true
			this.formataStatesCuradoria()

			this.modalLoading = true
			await Promise.all([curadoria.findById(payLoad.id), questoes.findQuantidadePorCuradoria(payLoad.id)]).then(data => {
				this.curadoria = data[0].data
				this.modalLoading = false
				this.curadoria.depth = payLoad.depth

				let i = null
				for (i in this.tiposQuestaoAssociadas) {
					let associacao = data[1].data.find(el => i === el.idTipoQuestao)
					associacao = associacao ? associacao.quantidade : 0
					this.tiposQuestaoAssociadas[i] = associacao
				}

				if (this.curadoria.curadoriaId === null) {
					this.mostrarTiposQuestoes = true
				} else {
					this.mostrarTiposQuestoes = false
				}
			})
		})
	},
	methods: {
		formataStatesCuradoria (novo) {
			this.mostrarTiposQuestoes = novo

			this.curadoria = {
				curadoriaId: null,
				nome: '',
				flagAtivo: true,
				codigo: '',
				depth: ''
			}

			let i = 0
			for (i in this.tiposQuestaoAssociadas) {
				this.tiposQuestaoAssociadas[i] = this.numeroDefaultAssociacao
			}

			this.isModalVisible = !this.isModalVisible
		},
		selectCuradoriaHandler (id, nome) {
			this.isModalDeleteVisible = true
			this.removeItem[0] = id
			this.removeItem[1] = nome
		},
		async deleteCuradoria () {
			this.isModalDeleteVisible = false
			try {
				await curadoria.delete(this.removeItem[0])
				this.removeItem = []
				window.notificationEM.open('', 'Curadoria Excluída com sucesso!', 'success')
				await curadoria.find()
					.then(res => {
						this.curadorias = res.data
					})
			} catch (error) {
				window.notificationEM.open('', error.response.data.msg, 'error')
			}

			// if (objCuradoria.status === 200) {
			// 	// this.curadorias = this.curadorias.filter(objCuradoria => objCuradoria.id !== this.removeItem[0])
			// 	window.notificationEM.open('', 'Curadoria Excluída com sucesso!', 'success')
			// 	await curadoria.find()
			// 		.then(res => {
			// 			this.curadorias = res.data
			// 		})
			// }
		},
		closeModal () {
			this.isModalVisible = false
			this.editarCuradoria = false
		},
		closeModalDelete () {
			this.isModalDeleteVisible = false
			this.removeItem = []
		},
		async salvarCuradoria () {
			if (!this.verificarCampos()) {
				return false
			}

			this.modalLoading = true

			try {
				let promise = null

				this.curadoria.codigo = this.curadoria.curadoriaId ? null : this.curadoria.codigo

				if (this.curadoria.id) {
					promise = curadoria.update(this.curadoria.id, this.curadoria)
				} else {
					this.editarCuradoria = false
					promise = curadoria.create(this.curadoria)
				}

				await promise.then(async data => {
					if (!this.curadoria.curadoriaId) {
						const curadoriaId = this.curadoria.id || data.data.id
						const associacoes = []
						let i = null

						for (i in this.tiposQuestaoAssociadas) {
							associacoes.push(questoes.associarTipoQuestaoCuradoria(curadoriaId, i, this.tiposQuestaoAssociadas[i]))
						}

						await Promise.all(associacoes)
					}
				})

				this.modalLoading = false

				window.notificationEM.open('', 'Curadoria salva com sucesso!', 'success')
				EventBus.$emit('reposta-cadastro-curadoria')
				// this.$store.state.showChildren = !this.$store.state.showChildren
				await curadoria.find()
					.then(res => {
						this.curadorias = res.data
					})
			} catch (error) {
				this.modalLoading = false
				window.notificationEM.open('', error.response.data.msg, 'error')
			}
			this.formataStatesCuradoria()
		},
		verificarCampos () {
			const errors = []

			if (this.curadoria.nome.trim().length <= 1) {
				errors.push('Nome da curadoria não preenchido!')
			}

			if (!this.curadoria.curadoriaId && (this.curadoria.codigo === null || this.curadoria.codigo.trim().length !== 2)) {
				errors.push('Códigos de curadoria devem possuir 2 caracteres')
			}

			if (errors.length > 0) {
				window.notificationEM.open('', errors.join('<br />'), 'error')
				return false
			} else {
				return true
			}
		},
		async exportTree () {
			const reportRequest = await curadoria.exportTree()

			window.open(reportRequest.data.arquivo)
		}
	}
}
</script>

<style lang="scss" scoped>
	.table-wrapper > .tree-menu {
		&:nth-child(even) {
			background-color: #F3F7FC;
		}

		&:nth-child(odd) {
			//background-color: #C7D2DF;
			background-color: #F3F7FC;
		}
	}

	#curadoria {
		max-width: 100%;
		overflow: auto;

		.relatorio {
			position: relative;
			top: 8px;
			background-color: $inputs-color;
			border-radius: $border-radius;
			text-align: right;

			> a, label {
				position: relative;
				display: inline-block;
				padding: 10px 45px 10px 30px;
				border-radius: 0 $border-radius $border-radius 0;
				font-family: $font-family-alternative;
				background: $success-color;
				color: $inputs-color;
				text-decoration: none;
				font-size: .9em;
				cursor: pointer;

				&:last-child {
					border-radius: 0 $border-radius $border-radius 0;
					margin-right: 0;
				}

				.fas {
					position: absolute;
					right: 0px;
					top: 5px;
					padding: 10px 15px;
				}

				&.reportMenuOpen {
					border-radius: 3px;
				}

				&.relatorio-geral {
					border-radius: 3px;
				}
			}

			> a {
				padding: 10px 45px;
				margin-right: 2px;
				border-radius: 0;
				transition: .167s linear;

				&:hover {
					background-color: $main-color;
				}
			}

			input {
				position: absolute;
				top: 0;
				left: 0;
				pointer-events: none;
				opacity: 0;

				~ ul {
					position: absolute;
					top: 50px;
					right: 0;
					z-index: 1;
					display: none;
					width: 30%;
					grid-template-columns: 1fr;
					padding: 15px 0;
					border-radius: $border-radius;
					box-shadow: 1px 1px 1px #0003;;
					background-color: #2952AB;
					color: $inputs-color;
					font-size: .9em;

					li {
						a {
							display: inline-block;
							width: 100%;
							padding: 10px 32px;
							text-align: center;
							color: inherit;
							text-decoration: inherit;
							transition: background-color .167 linear;

							&:hover {
								background-color: #FFF3;
							}
						}
					}
				}

				&:checked ~ ul {
					display: block;
				}
			}
		}

		.buttonAdd {
			display: flex;
			align-items: center;
			background-color: #3367d6;
			border-radius: 5px;
			cursor: pointer;
			color: #fff;
			font-family: $font-family;
			font-size: 1.0em;
			font-weight: 300;
			text-transform: uppercase;
			position: absolute;
			right: 30px;
			margin-bottom: 50px;
			top: 20px;
			padding: 16px 49px 15px 47px;
			justify-content: center;
		}

		.title-box {
			background-color: $main-color;
			color: #fff;
			font-family: $font-family;
			font-size: $font-size;
			font-weight: $font-weight-labels;
			display: grid;
			grid-template-columns: 3fr 4fr 1fr;
			padding: 10px;
			width: 100%;
			margin-top: 20px;
			margin-bottom: -15px;
		}

		.table-wrapper {
			padding-top: 30px;
			color: #000;
			width: 100%;

			.row {
				display: flex;
				align-items: center;
				background-color:#ebf0f9;
				margin-bottom: 20px;

				&:nth-child(n) {
					padding: 10px;
				}

				.column1 {
					background-color: $main-color;
					color: #fff;
					height: 25px;
					margin-right: 8px;
					width: 25px;
					font-size: 30px;
					padding-top: 10px;
				}

				.rowSub {
					flex-direction: column;
				}
			}
		}

		.table-wrapper .tree-menu:nth-child(n) {
			margin-bottom: 5px;
		}

		.modal-blackscreen {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 2;

			display: flex;
			align-items: center;
			justify-content: center;
			width: 100vw;
			height: 100vh;
			background-color: #0007;

			.modal {
				position: fixed;
				z-index: 1;
				width: 850px;
				min-height: 200px;
				padding: 20px;
				margin: 0 50px auto;
				border-radius: 5px;
				border: 1px solid #707070;
				background-color: #fff;
				color: #000;
				box-shadow: #6667 1px 1px 3px 3px;
				@media only screen and (max-width: 1200px) {
					width: calc(100% - 40px);
				}

				.modalLoading {
					position: absolute;
					display: grid;
					place-items: center;
					width: 100%;
					height: 100%;
					margin: -20px;
					background-color: #0004;
				}

				.adicionar {
					display: flex;
					align-items: center;
					margin-bottom: 15px;

					i {
						color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
						background-color: $main-color;
						font-size: 19px;
						height: 30px;
						width: 30px;
						margin-right: 6px;
					}

					p {
						color: $main-color;
						font-weight: bold;
						font-size: 17px;
						text-transform: uppercase;
					}
				}

				.two-columns {
					display: grid;
					grid-template-columns: 1fr 1fr;
					gap: 0 10px;
				}

				.input-container {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 5px 10px;
					margin-top: 10px;
					border-radius: 5px;
					border: 1px solid #70707D;

					label {
						padding: 5px 0;
						margin-right: 10px;
						color: #4F5C6B;
						font-size: 14px;

						.input-tipo-container {
							display: block;
							margin-bottom: -10px;
							font-size: 12px;
							color: #000;
						}
					}

					input {
						flex-grow: 1;
						border: none;
						border-radius: 5px;
					}
					input:disabled {
						background-color: #f8f8f8;
					}
				}

				.botoes {
					display: flex;
					align-items: flex-end;
					justify-content: flex-end;
					width: calc(100% + 40px); // 100% + padding left do container + padding-right do container (container => .modal)
					padding: 15px 20px;
					margin: 30px -20px -20px -20px;
					border-radius: 0 0 5px 5px;
					background-color: #F8F9FB;

					button {
						width: unset;
						padding: 12px 40px;
						border: 1px solid #336766;
						text-transform: uppercase;
						font-family: 'Roboto Condensed';
						font-weight: bold;
						font-size: 14px;
						transition: .227s background-color, .227s border-color;

						&:hover {
							background-color: #2951A7;
						}

						&.default {
							padding: 12px 25px;
							border: 1px solid #707070;

							&:hover {
								border-color: #E84949;
								background-color: #E84949;
								color: #FFF;
							}
						}
					}
				}
			}
		}
		.objectNotFound {
			margin-top: 50px;
			color: #000;
			text-align: center;
		}
	}
</style>
